import { StashPrimaryColorGroup } from '../../types/colors';

const CONTRAST_TEXT_MAP: { [key in StashPrimaryColorGroup]: string } = {
  blue: 'white',
  green: 'ice-900',
  ice: 'ice-900',
  orange: 'ice-900',
  purple: 'white',
  red: 'white',
  royal: 'white',
  seafoam: 'ice-900',
  teal: 'ice-900',
  yellow: 'ice-900',
};

type Shade = 'light' | 'main';

interface ColorSchemeArgs {
  shade: Shade;
  color: StashPrimaryColorGroup;
}

function bgColor(shade: Shade, color: StashPrimaryColorGroup) {
  if (shade === 'main') {
    return `${color}-500`;
  }

  const lightColorNo = color === 'ice' ? '200' : '100';

  return `${color}-${lightColorNo}`;
}

function textColor(shade: Shade, color: StashPrimaryColorGroup) {
  if (shade === 'main') {
    return CONTRAST_TEXT_MAP[color];
  }

  return `${color}-900`;
}

// TODO: Look into dynamically inferring contrast text color based on bg.
// Might be easier when tailwind is around.
// @see https://wunnle.com/dynamic-text-color-based-on-background
export default function colorScheme({ shade, color }: ColorSchemeArgs) {
  const computedBgColor = bgColor(shade, color);
  const computedTextColor = textColor(shade, color);

  return { computedBgColor, computedTextColor };
}
